import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useContext, useEffect, useState } from "react";
import toastService from "Root/profile/toastService";
import { Loading, PayPalButton } from "Components";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoading, setSettingsStoreAction } from "Root/profile/redux/actionCreators/makeActionCreator";
import { apiGetStripeKeys, apiRemoveCard, apiUpdateDefaultCard } from "Root/api/apiProfile";
import { defaultUserAccountData, setCardDataArray, setDeleteCardDataArray, } from "Root/profile/components/AccountSettings/utils";
import ProfileDataCardTitle from "../../common/ProfileDataCardTitle/ProfileDataCardTitle";
import PaymentMethodBox from "./PaymentMethodBox";
import accountStyles from "../styles.module.css";
import styles from "./style.module.css";
import FormRadio from "../../common/FormRadio";
import AccountContext from "../context";
import UnderlinedButton from "../../common/UnderlinedButton";
import PopUp from "../../ReactivateSubscription/ReactivationPopUp/reactivationPopUp";
import TopRightX from "../../common/TopRightX/TopRightX";
import BottomBar from "../../common/BottomBar";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import H3Font from "../../common/H3Font";
const PaymentMethod = ({ isReactivation, noEdit }) => {
    const { hash } = useLocation();
    const [loading, setLoading] = useState(false);
    const [stripeKey, setStripeKey] = useState("");
    const userAccount = useSelector((state) => state.accountSettings.userAccount);
    const [cardsData, setCardsData] = useState([]);
    const { editMode, updateEditModeState, onChangeData } = useContext(AccountContext);
    const isMobile = useScreenWidth() < 768;
    const [forceSubmit, setForceSubmit] = useState(false);
    const dispatch = useDispatch();
    const fetchStripeKey = async () => {
        const data = await apiGetStripeKeys();
        setStripeKey(data.publicKey);
    };
    const onChangeDefaultCard = async (card, value) => {
        try {
            setLoading(true);
            const { cardItemIndex, copyCardItems } = setCardDataArray(userAccount.cards, card, value);
            const cardResponse = await apiUpdateDefaultCard({ card_index: cardItemIndex, last4: card.last_four });
            setCardsData(cardResponse.card_data);
            dispatch(setSettingsStoreAction(true));
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
        finally {
            setLoading(false);
        }
    };
    const onDeleteCard = async (card) => {
        try {
            setLoading(true);
            const { cardItemIndex, copyCardItems } = setDeleteCardDataArray(userAccount.cards, card);
            const cardResponse = await apiRemoveCard({ card_index: cardItemIndex, last4: card.last_four });
            setCardsData(cardResponse.card_data);
            dispatch(setSettingsStoreAction(true));
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchStripeKey();
    }, []);
    useEffect(() => {
        if (userAccount.cards && userAccount.cards.length > 0 && userAccount.cards[0].brand) {
            setCardsData(userAccount.cards);
        }
        else {
            setCardsData(defaultUserAccountData.cards);
        }
    }, [userAccount]);
    useEffect(() => {
        if (hash && document.getElementById(hash.substr(1))) {
            // Check if there is a hash and if an element with that id exists
            document.getElementById(hash.substr(1))?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [hash]);
    const exitEditPayment = () => {
        updateEditModeState(false, "payment");
    };
    return (_jsx("div", { id: "paymentMethod", className: `${!noEdit ? "my-profile__basics-container" : ""} my-profile__basics"`, children: loading ? (_jsxs(_Fragment, { children: [_jsx(Loading, {}), _jsx(Loading, {})] })) : (_jsxs(_Fragment, { children: [_jsx(ProfileDataCardTitle, { title: "Payment Method", editMode: editMode.payment, setEdit: updateEditModeState, name: "payment", noEdit: noEdit }), _jsxs("div", { className: "my-profile__items-wrapper", children: [editMode.payment ? (stripeKey && (_jsx(Elements, { stripe: loadStripe(stripeKey), children: _jsx(PaymentMethodBox, { setCardsData: setCardsData, goBack: exitEditPayment, isReactivate: isReactivation }) }))) : (_jsx("div", { className: styles.cards_info_wrapper, children: _jsx("div", { className: styles.cards_wrapper, children: cardsData.map((item, i) => (_jsxs("div", { className: styles.cards_values, children: [_jsx(FormRadio, { label: "Default", name: "card", checked: item.default, value: i.toString(), id: item.exp ? String(item.exp + item.last_four) : "paypal-button", onChange: (_, checked) => onChangeDefaultCard(item, checked) }), _jsxs("div", { className: `${noEdit ? accountStyles.shipping_address_text_no_edit : ""} ${accountStyles.shipping_address_text}`, children: [_jsx("img", { src: item.img, alt: "card", className: styles.card_img }), item.last_four && (_jsxs(H3Font, { children: ["**** ****\u00A0", item.last_four] })), item.exp && (_jsxs(H3Font, { children: ["Exp.\u00A0", item.exp] }))] }), cardsData.length > 1 && item.brand !== "Paypal" && !item.default && (_jsx(UnderlinedButton, { label: "Remove", onClick: () => onDeleteCard(item) }))] }, `${i === 0 ? item.last_four : item.exp}`))) }) })), !noEdit && (_jsxs("div", { children: [_jsx("h6", { className: "header", children: "Or Use Paypal" }), _jsx(PayPalButton, { setLoading: (e) => dispatch(setGlobalLoading(e)), setCardsData: setCardsData })] }))] }), isMobile && isReactivation && stripeKey && (_jsxs(_Fragment, { children: [editMode.payment && isMobile && _jsx("div", { className: accountStyles.blurryface }), _jsx(Elements, { stripe: loadStripe(stripeKey), children: _jsxs(PopUp, { open: editMode.payment && isMobile, text: "Add Payment Method", close: () => {
                                    updateEditModeState(false, "payment");
                                }, children: [_jsx("div", { className: accountStyles.exit_container, children: _jsx(TopRightX, { onClick: () => updateEditModeState(false, "payment") }) }), _jsx(PaymentMethodBox, { setCardsData: setCardsData, goBack: exitEditPayment, isReactivate: isReactivation, forceSubmit: forceSubmit }), isReactivation && (_jsx(BottomBar, { submitLabel: "save payment", onSave: () => {
                                            setForceSubmit(true);
                                            updateEditModeState(false, "payment");
                                        } }))] }) })] }))] })) }));
};
export default PaymentMethod;
